<template>
  <span class="axis-badge" :class="'axis-badge--' + state">{{ axis }}</span>
</template>

<script>
/**
 * Small 20px square badge showing the check's axis letter (X/Y/Z/S/F).
 *
 * State modifier drives the background + foreground colors per the wireframe:
 * default (light teal) / pass (harvest teal) / fail (red) / active (primary).
 *
 * Wireframe reference: AVA Verification Wireframe.html lines 451-456.
 */
const VALID_AXES = ['X', 'Y', 'Z', 'S', 'F'];
const VALID_STATES = ['default', 'pass', 'fail', 'active'];

export default {
  name: 'AxisBadge',
  props: {
    axis: {
      type: String,
      required: true,
      validator: (v) => VALID_AXES.includes(v),
    },
    state: {
      type: String,
      default: 'default',
      validator: (v) => VALID_STATES.includes(v),
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/verification-tokens';

.axis-badge {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: grid;
  place-items: center;
  font-family: $vf-font-mono;
  font-size: 11px;
  font-weight: 700;

  background: #eef5f4;
  color: $vf-brand-castleton;

  &--pass {
    background: rgba(13, 148, 136, 0.1);
    color: $vf-harvest;
  }

  &--fail {
    background: rgba(183, 28, 28, 0.1);
    color: $vf-error;
  }

  &--active {
    background: $vf-primary;
    color: #fff;
  }
}
</style>
